import { apiClient } from "../api/apiClient.js";

// P150: the mobile activation key for one worker.
//
// The key itself is generated on the server, hashed, and returned exactly
// once - in the response to generateActivationKey below. Nothing in this file
// caches it, and there is no "fetch the key again" call, because no such
// endpoint exists: the server stores only a PBKDF2 hash. A sysadmin who loses
// the key regenerates it, which is also what invalidates the old one.
//
// Who may generate is decided by the backend from the caller's own session
// (SuperAdmin only). readActivationKeyStatus returns a canGenerate flag so the
// UI can avoid rendering a button that would 403, but that flag is a hint for
// the UI, never the gate.

const BASE_PATH = "/backoffice/worker-profiles";

function activationKeyPath(workerId) {
  if (!workerId) {
    throw new Error("activation key requests require a workerId");
  }
  return `${BASE_PATH}/${encodeURIComponent(workerId)}/activation-key`;
}

/** Current key state for one worker: whether a key exists, which generation, and how many phones are bound. Never the key. */
export function readActivationKeyStatus(workerId) {
  return apiClient.get(activationKeyPath(workerId));
}

/**
 * Mints a new key and returns it in plaintext for the only time it will ever
 * be readable. This also increments the generation and signs out every phone
 * activated under the previous one - the response's revokedDeviceCount says
 * how many, so the UI can state the real consequence.
 */
export function generateActivationKey(workerId) {
  return apiClient.post(activationKeyPath(workerId));
}
